import React from 'react';
import { trackEvent, BOOKING_SCREENING_URL } from '../lib/tracking';

export default function StickyMobileCta() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 min-[1200px]:hidden p-3 bg-[#ECEEF1]/95 backdrop-blur-md border-t border-[#D9DDE2] shadow-lg">
      <div className="max-w-md mx-auto">
        <a
          href={BOOKING_SCREENING_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent('cta_booking_click', { location: 'sticky_mobile' })}
          className="w-full flex items-center justify-center gap-2 h-12 px-4 rounded-xl bg-[#5A232E] text-white font-semibold text-sm shadow-sm hover:bg-[#431722] active:scale-[0.99] transition-all no-break whitespace-nowrap"
        >
          <i className="fa-solid fa-calendar-check text-xs" aria-hidden="true" />
          <span>Book en gratis afklaringssamtale</span>
        </a>
      </div>
    </div>
  );
}
